/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nav_status_beta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BETA`)
};

const es_nav_status_beta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BETA`)
};

const de_nav_status_beta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BETA`)
};

const nl_nav_status_beta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BETA`)
};

const fr_nav_status_beta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BETA`)
};

const it_nav_status_beta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BETA`)
};

const pt_br2_nav_status_beta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BETA`)
};

const pt_nav_status_beta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BETA`)
};

const ja_nav_status_beta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BETA`)
};

const zh_nav_status_beta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BETA`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nav_status_beta = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nav_status_beta(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nav_status_beta", locale)
	if (locale === "en") return en_nav_status_beta(inputs)
	if (locale === "es") return es_nav_status_beta(inputs)
	if (locale === "de") return de_nav_status_beta(inputs)
	if (locale === "nl") return nl_nav_status_beta(inputs)
	if (locale === "fr") return fr_nav_status_beta(inputs)
	if (locale === "it") return it_nav_status_beta(inputs)
	if (locale === "pt-BR") return pt_br2_nav_status_beta(inputs)
	if (locale === "pt") return pt_nav_status_beta(inputs)
	if (locale === "ja") return ja_nav_status_beta(inputs)
	return zh_nav_status_beta(inputs)
};